import React from "react";
import ContentForPage from "../../../containers/ContentForPage";
import PageLayout from "../../UI/PageLayout";
import { GenericReportingDropdowns } from "../../../containers/GenericReportingDropdowns";

const LtrTab = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
          <ContentForPage pageName="product_performance_ltr" />
    </div>
  );
};

export default LtrTab; 